import { BASE_URL } from '@/config'

export async function getSIDomains() {
  try {
    const response = await fetch(`${BASE_URL}/graphs/cybersecurity_concept/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar capacidades operacionais'
      )
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar conceitos de cibersegurança:', error)
    throw error
  }
}

export async function getSIDomainsByIdEnterprise(enterpriseId) {
  console.log(
    'ID da empresa getCybersecurityConceptsByIdEnterprise:',
    enterpriseId
  )
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/si-domains/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar capacidades operacionais'
      )
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error(
      'Erro ao buscar conceitos de cibersegurança da empresa:',
      error
    )
    throw error
  }
}
